/** @format */

import React, { FormEvent, useContext, useState } from "react";
import "./Login.css";
import { Stack } from "react-bootstrap";
import UserContext from "../../Contexts/User";
import { LoginModes, SignupPayload } from "../../common/models/Login";
import { useTranslation } from "../../common/models/Dictionary";
import AppContext from "../../Contexts/AppContext";
import Styles from "./styles";
import Login, { isTelegramWebView } from "./Login";
import Signup from "./Signup";
import { User as AuthUser } from "@firebase/auth";
import { AuthProvider } from "firebase/auth";
import { Callback } from "../../common/models/utils";
import { texts } from "./texts";
import { ToastContent, ToastOptions } from "react-toastify/dist/types";
import { ToastType } from "../../Contexts/Notification";
import { useLocation } from "react-router-dom";
import Refer from "../../Pages/Refer";
import ForgetPassword from "./ForgetPassword";
import { useTelegramLogin } from "./useTelegramlogin";

const title = {
  // [LoginModes.LOGIN]: texts.login,
  [LoginModes.LOGIN]: texts.onekeylogin,
  [LoginModes.SIGNUP]: texts.signUp,
};

export type LoginAndSignupProps = {
  authProvider: (
    setUser: (user: AuthUser) => void,
    provider: AuthProvider,
    showToast: (
      content: ToastContent,
      type?: ToastType,
      options?: ToastOptions | undefined
    ) => void
  ) => Promise<void>;
  loginAction: (
    e: FormEvent<HTMLFormElement>,
    callback: Callback<AuthUser>
  ) => Promise<void>;
  signupAction: (
    payload: SignupPayload,
    callback: Callback<AuthUser>
  ) => Promise<boolean>;
};

const LoginAndSignup = ({
  authProvider,
  loginAction,
  signupAction,
}: LoginAndSignupProps) => {
  const translate = useTranslation();
  const {isLoading } = useTelegramLogin();
  const location = useLocation();
  const search = location.search;
  const { setUser } = useContext(UserContext);
  const { signup, setSignup } = useContext(AppContext);
  const [forgetPassword, setForgetPassword] = useState(false);
  const mode = signup ? LoginModes.SIGNUP : LoginModes.LOGIN;
  const refer = new URLSearchParams(search).get("refer");
  const isTelegram = isTelegramWebView();
  return (
    <Stack
      gap={2}
      className='flex justify-content-center align-items-center'
      style={{
        //  background: "var(--light-purple)", 
         height: "100%" }}
    >
      <div className='container-center-horizontal'>
        <div className='login-signin screen'>
          {!isTelegram && <Styles.Title style={{color:"white"}}>{translate(title[mode])}</Styles.Title>}
          {/* {!forgetPassword ? (
            <Styles.Title style={{color:"white"}}>{translate(title[mode])}</Styles.Title>
          ) : (
            <Styles.Title style={{color:"white"}}>{translate("Forget Password")}</Styles.Title>
          )} */}
          {mode === LoginModes.LOGIN && !forgetPassword && (
            <Login
              setForgetPassword={setForgetPassword}
              setUser={setUser}
              setSignup={setSignup}
              authProvider={authProvider}
              login={loginAction}
            />
          )}
          {mode === LoginModes.LOGIN && forgetPassword && (
            <ForgetPassword
              setForgetPassword={setForgetPassword}
              setUser={setUser}
              setSignup={setSignup}
              authProvider={authProvider}
              login={loginAction}
            />
          )}
          {mode === LoginModes.SIGNUP && (
            <>
              {/* {refer && (<Refer />)} */}
              {
                <Signup
                  setUser={setUser}
                  setSignup={setSignup}
                  signup={signupAction}
                  authProvider={authProvider}
                />
              }
            </>
          )}
        </div>
      </div>
    </Stack>
  );
};

export default LoginAndSignup;
